/**
 * View split left and right parts, default 50% 50% relation
 *
 */
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";
const useCenterStyles = makeThemedStyles("Center", (theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
const Center = (
  props: React.PropsWithChildren<{
    gap?: string;
  }>
) => {
  const styles = useCenterStyles();
  return (
    <div
      className={styles.root}
      style={{
        gap: props.gap,
      }}
    >
      {props.children}
    </div>
  );
};

export default Center;
